export default __webpack_public_path__ + "static/media/EasytoUnderstand.b9a61614.svg";